import React from 'react'
import { IoLogoWhatsapp } from 'react-icons/io'
import { FaHeart, FaUsers, FaComments, FaLightbulb } from 'react-icons/fa'
import { MdOutlineDone } from 'react-icons/md'

// Import lecture images
import LectureImage1 from '../images/lecture/WhatsApp Image 2025-06-03 at 15.46.49.jpeg'
import LectureImage2 from '../images/lecture/WhatsApp Image 2025-06-03 at 17.21.40.jpeg'

export default function Lectures() {
  const whatsappMessage = encodeURIComponent("היי אשמח לתאם הרצאה")
  
  return (
    <div id="lectures" className="p-4 bg-gradient-to-br from-gray-50 to-white py-16 ">
      <div className="max-w-[1200px] mx-auto">
        
        {/* Header */}
        <div className="text-center mb-16">
          <h1 dir="rtl" className="text-5xl md:text-6xl font-extrabold text-primary mb-4">
            הרצאות
          </h1>
          <p dir="rtl" className="text-xl md:text-2xl text-gray-600 max-w-[800px] mx-auto">
            הרצאות מרגשות ומעשיות לזוגות, קבוצות הורים, ארגונים וקהילות
          </p>
        </div>

        {/* Main Lecture Card */}
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden mb-12">
          
          {/* Lecture Header */}
          <div className="bg-card text-white p-8 text-center">
            <h2 dir="rtl" className="text-4xl md:text-5xl font-extrabold mb-4">
              "המתכון לזוגיות מאושרת"
            </h2>
            <p className="text-xl md:text-2xl opacity-90">
              מלי דיין, יועצת זוגית
            </p>
          </div>

          <div className="p-8">
            
            {/* Images Section - Compact */}
            <div className="mb-8">
              <div className="flex justify-center gap-4 mb-6">
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shadow-lg">
                  <img 
                    src={LectureImage1} 
                    alt="הרצאה - המתכון לזוגיות מאושרת" 
                    className="w-full h-full object-cover hover:scale-110 duration-300 cursor-pointer"
                  />
                </div>
                <div className="w-32 h-32 md:w-40 md:h-40 rounded-xl overflow-hidden shadow-lg">
                  <img 
                    src={LectureImage2} 
                    alt="צילום מהקהל בהרצאה" 
                    className="w-full h-full object-cover hover:scale-110 duration-300 cursor-pointer"
                  />
                </div>
              </div>
              
              <p dir="rtl" className="text-center text-gray-600 text-lg">
                תמונות מההרצאה<br /> "המתכון לזוגיות מאושרת"
              </p>
            </div>

            {/* Main Description */}
            <div dir="rtl" className="mb-8">
              <div className="bg-gradient-to-l from-primary/10 to-secondary/10 p-6 rounded-2xl mb-6">
                <h3 className="text-2xl md:text-3xl font-bold mb-4 text-center">
                  מרגישים שהאהבה שלכם חזקה, אבל לא תמיד יודעים לשמור עליה קרובה ומחוברת?
                </h3>
              </div>
              
              <p className="text-lg md:text-xl leading-relaxed mb-6">
                במפגש איתי אני משתפת אתכם בכלים פשוטים וישימים לחיזוק הקשר, כדי שהזוגיות שלכם תישאר מקור של שמחה, חום ואהבה.
              </p>
              
              <p className="text-lg md:text-xl leading-relaxed mb-6">
                כל זה קורה בהרצאה מרגשת, קלילה ומעשית, שבה אני משתפת כלים פשוטים ויישומיים שיכולים לעשות את כל ההבדל –
                איך לשמור על זוגיות קרובה, מחוברת ומלאת חמלה, שמחה ואהבה.
              </p>
            </div>

            {/* Topics Section */}
            <div dir="rtl" className="mb-8">
              <h3 className="text-3xl md:text-4xl font-bold text-center mb-8 text-primary">
                הנושאים המרכזיים בהרצאה:
              </h3>
              
              {/* Topics Grid */}
              <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-6 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <FaHeart className="text-3xl text-primary ml-3" />
                    <h4 className="text-xl font-bold">כלים לחיזוק הקשר הזוגי</h4>
                  </div>
                  <p className="text-gray-700">גם בזמנים מאתגרים</p>
                </div>
                
                <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-6 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <FaComments className="text-3xl text-primary ml-3" />
                    <h4 className="text-xl font-bold">הבנה עמוקה</h4>
                  </div>
                  <p className="text-gray-700">של תקשורת זוגית מקרבת</p>
                </div>
                
                <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-6 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <FaLightbulb className="text-3xl text-primary ml-3" />
                    <h4 className="text-xl font-bold">דרכים לשימור</h4>
                  </div>
                  <p className="text-gray-700">אהבה וחברות לאורך זמן</p>
                </div>
                
                <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-6 rounded-2xl">
                  <div className="flex items-center mb-4">
                    <FaUsers className="text-3xl text-primary ml-3" />
                    <h4 className="text-xl font-bold">השראה והומור</h4>
                  </div>
                  <p className="text-gray-700">ונקודת מבט חדשה על הזוגיות שלכם</p>
                </div>
              </div>
            </div>

            {/* Audience and Format */}
            <div dir="rtl" className="mb-8">
              <h3 className="text-3xl md:text-4xl font-bold text-center mb-8 text-primary">
                למי מתאימה ההרצאה?
              </h3>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                <div className="bg-gradient-to-br from-primary/10 to-secondary/10 p-6 rounded-2xl text-center hover:scale-105 transition-transform duration-300">
                  <div className="flex justify-center mb-4">
                    <FaHeart className="text-4xl text-primary" />
                  </div>
                  <h4 className="text-lg font-bold mb-2">זוגות</h4>
                  <p className="text-gray-600 text-sm">לחיזוק הקשר והאהבה</p>
                </div>
                
                <div className="bg-gradient-to-br from-primary/10 to-secondary/10 p-6 rounded-2xl text-center hover:scale-105 transition-transform duration-300">
                  <div className="flex justify-center mb-4">
                    <FaUsers className="text-4xl text-primary" />
                  </div>
                  <h4 className="text-lg font-bold mb-2">קבוצות הורים</h4>
                  <p className="text-gray-600 text-sm">לחיזוק הקשר המשפחתי</p>
                </div>
                
                <div className="bg-gradient-to-br from-primary/10 to-secondary/10 p-6 rounded-2xl text-center hover:scale-105 transition-transform duration-300">
                  <div className="flex justify-center mb-4">
                    <FaLightbulb className="text-4xl text-primary" />
                  </div>
                  <h4 className="text-lg font-bold mb-2">ארגונים וחברות</h4>
                  <p className="text-gray-600 text-sm">לחיזוק צוות העבודה</p>
                </div>
                
                <div className="bg-gradient-to-br from-primary/10 to-secondary/10 p-6 rounded-2xl text-center hover:scale-105 transition-transform duration-300">
                  <div className="flex justify-center mb-4">
                    <FaComments className="text-4xl text-primary" />
                  </div>
                  <h4 className="text-lg font-bold mb-2">קהילות ומוסדות</h4>
                  <p className="text-gray-600 text-sm">לחיזוק הקהילה</p>
                </div>
              </div>
              
              <div className="bg-gradient-to-r from-primary/5 to-secondary/5 p-6 rounded-2xl text-center">
                <p className="text-lg font-semibold text-primary">
                  ✨ ניתן להזמין גם להרצאות בזום או במפגש פרונטלי ✨
                </p>
              </div>
            </div>

            {/* Booking Button */}
            <div className="text-center">
              <a 
                href={`https://wa.me/972509933553?text=${whatsappMessage}`}
                className="inline-flex items-center bg-card text-white px-8 py-4 rounded-full text-xl font-bold hover:scale-105 duration-300 shadow-2xl"
              >
                <IoLogoWhatsapp className="text-3xl mr-3" />
                <span> להזמנת הרצאה לחצו כאן</span>
              </a>
            </div>
          </div>
        </div>

        {/* Additional Info Card */}
        <div className="bg-card text-white p-8 rounded-3xl text-center">
          <h3 dir="rtl" className="text-2xl md:text-3xl font-bold mb-4">
            מעוניינים בהרצאה מותאמת אישית?
          </h3>
          <p dir="rtl" className="text-lg md:text-xl mb-6">
            אני מתאימה את ההרצאה לקהל הספציפי שלכם ולנושאים שהכי מעניינים אתכם
          </p>
          <p className="text-lg opacity-90 mb-4">
            צרו קשר ונתאם יחד את ההרצאה המושלמת עבורכם
          </p>
          <div className="text-lg font-semibold">
            <p className="mb-2">מלי</p>
            <a 
              href="tel:+972509933553"
              className="inline-block text-white hover:text-gray-200 transition-colors duration-300"
            >
             050-993-3553
            </a>
          </div>
        </div>

      </div>
    </div>
  )
} 